import * as React from 'react';
const SvgLaptop = props => (
  <svg xmlns='http://www.w3.org/2000/svg' width={800} height={800} fill='none' viewBox='0 0 24 24' {...props}>
    <path
      stroke={props.stroke || '#000'}
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2}
      d='M10 18h4M7.2 3h9.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C20 4.52 20 5.08 20 6.2v5.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C18.48 15 17.92 15 16.8 15H7.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C4 13.48 4 12.92 4 11.8V6.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C5.52 3 6.08 3 7.2 3ZM4.589 21H19.41c.857 0 1.286 0 1.544-.18a1 1 0 0 0 .416-.674c.046-.312-.145-.695-.529-1.462l-.515-1.03c-.482-.964-.723-1.445-1.082-1.797a3 3 0 0 0-1.12-.693C17.648 15 17.11 15 16.033 15H7.966c-1.077 0-1.616 0-2.091.164a3 3 0 0 0-1.121.693c-.36.352-.6.833-1.082 1.796l-.515 1.032c-.384.766-.575 1.15-.53 1.461a1 1 0 0 0 .417.674c.258.18.687.18 1.544.18Z'
    />
  </svg>
);
export default SvgLaptop;
